export const COCREATION_TOOLS_ORIGIN = "https://cocreationtools.bellomyonline.com";
export const COCREATION_TOOLS_HANDOFF_PATH = "/launch/cocreation";
export const COCREATION_TOOLS_LAUNCH_ENDPOINT = "/api/v1/auth/cocreation-launch";

const COCREATION_TOOLS_CALLBACK_PATH = "/sso";

type LaunchResponse = {
  launchUrl?: unknown;
};

export class CocreationSsoLaunchError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "CocreationSsoLaunchError";
  }
}

export const validateCocreationLaunchUrl = (value: unknown): string => {
  if (typeof value !== "string" || !value.trim()) {
    throw new CocreationSsoLaunchError("Cocreation Tools did not return a launch URL.");
  }

  let url: URL;
  try {
    url = new URL(value);
  } catch {
    throw new CocreationSsoLaunchError("Cocreation Tools returned an invalid launch URL.");
  }

  if (
    url.origin !== COCREATION_TOOLS_ORIGIN ||
    url.protocol !== "https:" ||
    url.pathname !== COCREATION_TOOLS_CALLBACK_PATH ||
    Array.from(url.searchParams.entries()).length !== 1 ||
    !url.searchParams.get("ticket") ||
    url.username ||
    url.password ||
    url.hash
  ) {
    throw new CocreationSsoLaunchError("Cocreation Tools returned an untrusted launch URL.");
  }

  return url.toString();
};

export const createCocreationToolsLaunch = async (
  token: string | null,
  request: typeof fetch = fetch,
): Promise<string> => {
  if (!token) {
    throw new CocreationSsoLaunchError("Your Panel Insights session is no longer available.");
  }

  let response: Response;
  try {
    response = await request(COCREATION_TOOLS_LAUNCH_ENDPOINT, {
      method: "POST",
      body: JSON.stringify({}),
      cache: "no-store",
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch {
    throw new CocreationSsoLaunchError("Cocreation Tools could not be reached.");
  }

  if (!response.ok) {
    throw new CocreationSsoLaunchError("Cocreation Tools could not start your session.");
  }

  let payload: LaunchResponse;
  try {
    payload = (await response.json()) as LaunchResponse;
  } catch {
    throw new CocreationSsoLaunchError("Cocreation Tools returned an invalid response.");
  }

  return validateCocreationLaunchUrl((payload as { data?: LaunchResponse }).data?.launchUrl);
};
